import { render, staticRenderFns } from "./GlideCarousel.vue?vue&type=template&id=133eaa7a&scoped=true"
import script from "./GlideCarousel.vue?vue&type=script&lang=ts"
export * from "./GlideCarousel.vue?vue&type=script&lang=ts"
import style0 from "./GlideCarousel.vue?vue&type=style&index=0&id=133eaa7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133eaa7a",
  null
  
)

export default component.exports